import PromoCodePage from "../../components/PromoCode/PromoCodePage";

const PromoCodeContainer = ({ isMobileVersion }) => {
  return <PromoCodePage isMobileVersion={isMobileVersion} />;
};

export default PromoCodeContainer;
